import {jsx as _jsx} from "react/jsx-runtime";
import {cn} from '../cn'

const ChevronRight = ({className, ...props}) => (
  _jsx('svg', {
    viewBox: "0 0 24 24"   ,
    'aria-hidden': "true",
    focusable: "false",
    ...props,
    className: cn(
      'inline-block h-[1em] w-[1em] shrink-0 select-none fill-current text-[24px]',
      className
    ),
 children: 
    _jsx('path', { d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"       ,} )
  })
)

export default ChevronRight
